import React from 'react'

const Bar: React.FC<{ className: string }> = ({ className }) => (
  <div className={`animate-pulse rounded bg-gray-200 motion-reduce:animate-none ${className}`} />
)

const CardSkeleton: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`flex flex-col gap-4 rounded-[20px] bg-white p-4 md:rounded-[30px] md:p-6 ${className ?? ''}`}>
    <Bar className="h-3 w-3/4" />
    <Bar className="h-3 w-1/2" />
    <Bar className="h-3 w-2/3" />
    <Bar className="h-3 w-2/5" />
  </div>
)

/** The same four blocks as the loaded dashboard, so nothing jumps when the figures arrive. */
export const DashboardSkeleton: React.FC = () => (
  <div role="status" aria-busy="true" className="flex flex-col gap-8">
    <span className="sr-only">Dashboard wird geladen</span>
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" aria-hidden>
      <div className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4">
        <Bar className="h-3 w-1/3" />
        <Bar className="h-9 w-1/4" />
        <Bar className="h-3 w-1/2" />
      </div>
      <div className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4">
        <Bar className="h-3 w-1/3" />
        <Bar className="h-9 w-1/3" />
        <Bar className="h-3 w-2/3" />
      </div>
    </div>
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.1fr_1fr]" aria-hidden>
      <CardSkeleton className="min-h-[260px]" />
      <CardSkeleton className="min-h-[260px]" />
    </div>
    <div aria-hidden>
      <CardSkeleton className="min-h-[300px]" />
    </div>
  </div>
)
